// Value for the pinned "Competition Average" option. Negative so it never collides with a real
// entity id (always positive); not -1, which is the indexOf/findIndex "not found" result.
export const COMPETITION_AVERAGE_OPTION_VALUE = -2;

export const COMPETITION_AVERAGE_SCOPE = 'competitionAverage';
